"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _emotion = require("emotion");

var _utils = require("./utils");

var _colors = require("./colors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var divStyle = ".focusable-checkbox {\n  position: absolute; // take it out of document flow\n  opacity: 0; // hide it\n  margin: 10px 0;\n\n  & + label {\n    position: relative;\n    cursor: pointer;\n    padding: 0;\n    font-weight: 400;\n  }\n\n  // Box.\n  & + label:before {\n    content: '';\n    margin-right: 10px;\n    display: inline-block;\n    vertical-align: text-top;\n    background: white;\n    width: 18px;\n    height: 18px;\n  }\n\n  // Default box when not checked, indeterminate, hovered, focused, or disabled\n  &:not(:checked):not(.focusable-checkbox-indeterminate):not(:hover):not(:focus):not(:disabled) + label:before {\n    border: 2px solid ".concat(_colors.coal, ";\n    border-radius: 2px;\n  }\n\n  // Hovered box when not disabled, or Focused box when not checked\n  &:not(:disabled):hover + label:before, &:not(:checked):focus + label:before {\n    border: 2px solid ").concat(_colors.teal.base, ";\n    border-radius: 2px;\n  }\n   \n  // Focused box when checked or indeterminate\n  &:focus + label:before {\n    box-shadow: 0px 0px 3px ").concat(_colors.teal.base, ";\n  }\n  \n  // Box checked\n  &:checked + label:before, &.focusable-checkbox-indeterminate + label:before {\n    background: ").concat(_colors.teal.base, ";\n    outline: 0;\n  }\n  \n  // Disabled state label.\n  &:disabled + label {\n    color: ").concat(_colors.alloy, ";\n    cursor: auto;\n  }\n\n  // Disabled box when not checked\n  &:not(:checked):disabled + label:before {\n    box-shadow: none;\n    border: 2px solid ").concat(_colors.alloy, ";\n  }\n  \n  // Disabled box when checked or indeterminate \n  &:checked:disabled + label:before, &.focusable-checkbox-indeterminate:disabled + label:before {\n    background: ").concat(_colors.alloy, ";\n  }\n\n  &:not(:checked).focusable-checkbox-indeterminate + label:after {\n    content: '';\n    position: absolute;\n    left: 4px;\n    top: 8px;\n    color: white;\n    border: 1px solid white;\n    border-radius: 2px;\n    \n    width: 10px;\n    height: 1px;\n  }\n\n  &:checked + label:after {\n    content: 'L';\n    position: absolute;\n    left: 6px;\n    top: -1px;\n    color: white;\n    font-weight: 600;\n    transform: scaleX(-1) rotate(-45deg);\n  }\n}");

var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      indeterminate = _ref.indeterminate,
      onChange = _ref.onChange,
      className = _ref.className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {
    margin: '10px 0'
  } : _ref$style,
      label = _ref.label,
      payload = _ref.payload,
      whiteBackground = _ref.whiteBackground,
      _onBlur = _ref.onBlur,
      _onFocus = _ref.onFocus,
      inline = _ref.inline,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "indeterminate", "onChange", "className", "style", "label", "payload", "whiteBackground", "onBlur", "onFocus", "inline"]);

  var _useState = (0, _react.useState)(['focusable-checkbox']),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      classNames = _useState2[0],
      setClassNames = _useState2[1];

  var inputId = (0, _utils.useMemoizedId)({
    id: id,
    label: label
  });
  var backgroundColor = whiteBackground ? 'white' : undefined;
  (0, _react.useEffect)(function () {
    if (indeterminate) {
      setClassNames(function (currentClassNames) {
        return [].concat((0, _toConsumableArray2["default"])(currentClassNames), ['focusable-checkbox-indeterminate']);
      });
    } else {
      setClassNames(function (currentClassNames) {
        return currentClassNames.filter(function (name) {
          return name !== 'focusable-checkbox-indeterminate';
        });
      });
    }
  }, [indeterminate]);

  var onCheckBoxChange = function onCheckBoxChange(e) {
    return onChange && onChange(e, payload);
  };

  return _react["default"].createElement("div", {
    className: (0, _emotion.cx)((0, _emotion.css)(_templateObject(), divStyle), className),
    style: _objectSpread({}, style, {
      backgroundColor: backgroundColor,
      display: inline ? 'inline' : 'block'
    })
  }, _react["default"].createElement("input", (0, _extends2["default"])({}, rest, {
    className: classNames.join(' '),
    onChange: onCheckBoxChange,
    onBlur: function onBlur(e) {
      return _onBlur && _onBlur(e);
    },
    onFocus: function onFocus(e) {
      return _onFocus && _onFocus(e);
    },
    type: "checkbox",
    id: inputId
  })), _react["default"].createElement("label", {
    htmlFor: inputId
  }, label));
};

Checkbox.propTypes = {
  id: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  indeterminate: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  whiteBackground: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  payload: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  style: _reactStyleProptype["default"],
  inline: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  disabled: false,
  className: '',
  whiteBackground: false
};
var _default = Checkbox;
exports["default"] = _default;